(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7178],{

/***/ 74068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ FormInput; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["register", "errorMessage", "defaultValue", "annotation", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FormInput = function FormInput(_ref) {
  var register = _ref.register,
      errorMessage = _ref.errorMessage,
      defaultValue = _ref.defaultValue,
      annotation = _ref.annotation,
      as = _ref.as,
      formInputProps = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Input, _objectSpread(_objectSpread(_objectSpread({}, formInputProps), register), {}, {
      defaultValue: defaultValue,
      as: as
    })), errorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormErrorMessage, {
      children: errorMessage.message
    }), annotation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Annotation, {
      children: annotation
    })]
  });
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "FormInput__Input",
  componentId: "sc-gcxing-0"
})(["height:", ";border:1px solid #707070;padding:17px 20px 19px;width:100%;font-size:16px;letter-spacing:0.28px;resize:vertical;&::placeholder{color:", ";}@media screen and (max-width:1047px){max-width:none;}"], function (_ref2) {
  var as = _ref2.as;
  return as === 'textarea' ? '304px' : '56px';
}, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var Annotation = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "FormInput__Annotation",
  componentId: "sc-gcxing-1"
})(["font-size:12px;color:", ";margin-top:7px;&::before{content:'\u203B';}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var FormErrorMessage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "FormInput__FormErrorMessage",
  componentId: "sc-gcxing-2"
})(["color:", ";font-size:12px;font-weight:bold;margin-top:5px;&::before{content:'\u30A8\u30E9\u30FC\uFF1A';}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.red */ .r.colors.red);

/***/ }),

/***/ 24754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FormLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var FormLabel = function FormLabel(_ref) {
  var text = _ref.text,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      inputId = _ref.inputId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
    "data-required": isRequired,
    htmlFor: inputId,
    children: text
  });
};
var LabelField = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:14px;display:block;font-weight:normal;color:#fff;border-radius:4px;padding:0 14px;line-height:22px;margin-right:14px;letter-spacing:0.28px;white-space:nowrap;"]);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "FormLabel__Label",
  componentId: "sc-1cf08y1-0"
})(["font-size:16px;font-weight:bold;line-height:26px;letter-spacing:0.32px;display:flex;align-items:baseline;&[data-required='true']{&::before{", ";content:'\u5FC5\u9808';background-color:", ";}}&[data-required='false']{&::before{", ";content:'\u4EFB\u610F';background-color:", ";}}"], LabelField, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, LabelField, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 86053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ corporationLabels; }
/* harmony export */ });
/* unused harmony export formData */
var corporationLabels = {
  company: {
    text: '会社名',
    isRequired: false,
    inputId: 'company'
  },
  fullName: {
    text: 'ご氏名',
    isRequired: true,
    inputId: 'lastName'
  },
  lastName: {
    text: '姓',
    isRequired: 'none',
    inputId: 'lastName'
  },
  firstName: {
    text: '名',
    isRequired: 'none',
    inputId: 'firstName'
  },
  email: {
    text: 'Eメールアドレス',
    isRequired: true,
    inputId: 'email'
  },
  tel: {
    text: '電話番号',
    isRequired: false,
    inputId: 'tel'
  },
  title: {
    text: 'お問い合せ件名',
    isRequired: false,
    inputId: 'title'
  },
  detail: {
    text: 'お問い合せの詳細をご記入ください',
    isRequired: true,
    inputId: 'detail'
  }
};
var formData = {
  company: '株式会社 TRIAL',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  tel: '009-0000-0000',
  title: '件名が入りますダミー',
  detail: 'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。'
};

/***/ }),

/***/ 85979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CorporationPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/store/index.ts
var store = __webpack_require__(61268);
// EXTERNAL MODULE: ./src/store/contactCorporation/slice.ts
var slice = __webpack_require__(10019);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/pages/Contact/Corporation/CorporationLabel.ts
var CorporationLabel = __webpack_require__(86053);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
// EXTERNAL MODULE: ./src/components/elements/FormInput/index.tsx
var FormInput = __webpack_require__(74068);
// EXTERNAL MODULE: ./src/components/elements/FormLabel/index.tsx
var FormLabel = __webpack_require__(24754);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Contact/Corporation/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var CorporationPage = function CorporationPage() {
  var form = (0,store/* useSelector */.v9)(function (state) {
    return state.contactCorporation;
  });
  var dispatch = (0,store/* useDispatch */.I0)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var router = (0,next_router.useRouter)();

  var onSubmit = function onSubmit(data) {
    dispatch((0,slice/* setContactCorporation */.IJ)(data));
    router.push('/contact/corporation/confirm');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u4E8B\u696D\u30FB\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u4E8B\u696D\u30FB\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B\u306F\u3053\u3061\u3089\u304B\u3089\u3002",
      ogp: {
        type: 'article',
        url: 'contact/corporation/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CorporationMain, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
        titleText: "Corporate",
        subTitleText: "\u6CD5\u4EBA",
        color: "normal"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 69,
          sp: 59
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Note, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: ["\u5404\u30B5\u30FC\u30D3\u30B9\u30FB\u5B50\u4F1A\u793E\u3078\u306E\u3054\u63D0\u6848\u306F\u3001\u5404\u7A93\u53E3\u3078\u76F4\u63A5\u304A\u554F\u5408\u305B\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u65B0\u898F\u4E8B\u696D\u9818\u57DF\u306A\u3069\u5BFE\u8C61\u30B5\u30FC\u30D3\u30B9\u304C\u3054\u4E0D\u660E\u306E\u5834\u5408\u306F\u305D\u306E\u65E8\u3092\u8A18\u8F09\u306E\u3046\u3048\u3001\u4EE5\u4E0B\u304A\u554F\u5408\u305B\u30D5\u30A9\u30FC\u30E0\u306B\u3066\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "\u304A\u554F\u5408\u305B\u306E\u5185\u5BB9\u306B\u3088\u3063\u3066\u306F\u3001\u56DE\u7B54\u306B\u6642\u9593\u3092\u8981\u3059\u308B\u5834\u5408\u3084\u3001\u56DE\u7B54\u3057\u304B\u306D\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: "\u30C9\u30E1\u30A4\u30F3\u6307\u5B9A\u53D7\u4FE1\u3092\u3054\u5229\u7528\u306E\u5834\u5408\u306F\u3001\u30C9\u30E1\u30A4\u30F3@dena.jp\u3001@dena.com\u304B\u3089\u306E\u53D7\u4FE1\u8A31\u53EF\u8A2D\u5B9A\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 100,
          sp: 69
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
        method: "post",
        noValidate: true,
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormBackground, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormMain, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.company */.n.company))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
              id: "company",
              type: "text",
              register: register('company'),
              defaultValue: form.company
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.fullName */.n.fullName))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormGroup, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.lastName */.n.lastName)), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
                  id: "lastName",
                  type: "text",
                  register: register('lastName', {
                    required: {
                      value: true,
                      message: '入力してください。'
                    }
                  }),
                  errorMessage: errors.lastName,
                  defaultValue: form.lastName
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormGroup, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.firstName */.n.firstName)), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
                  id: "firstName",
                  type: "text",
                  register: register('firstName', {
                    required: {
                      value: true,
                      message: '入力してください。'
                    }
                  }),
                  errorMessage: errors.firstName,
                  defaultValue: form.firstName
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.email */.n.email))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
              id: "email",
              type: "email",
              register: register('email', {
                required: {
                  value: true,
                  message: '入力してください。'
                },
                pattern: {
                  message: '正しい形式で入力してください。',
                  value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                }
              }),
              placeholder: "\u4F8B\uFF09XXX@XXX.ne.jp",
              errorMessage: errors.email,
              defaultValue: form.email
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.tel */.n.tel))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
              id: "tel",
              type: "tel",
              maxLength: 13,
              register: register('tel', {
                pattern: {
                  message: '正しい形式で入力してください。',
                  value: /^[-0-9]+$/
                }
              }),
              placeholder: "\u4F8B\uFF0900-0000-0000",
              errorMessage: errors.tel,
              defaultValue: form.tel
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.title */.n.title))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
              id: "title",
              type: "text",
              register: register('title'),
              defaultValue: form.title,
              placeholder: "\u4F8B\uFF09XXX\u306B\u3064\u3044\u3066",
              annotation: "\u521D\u3081\u3066\u3067\u306F\u306A\u3044\u5834\u5408\u3001\u904E\u53BB\u306E\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u3092\u7C21\u6613\u306B\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* FormLabel */.l, _objectSpread({}, CorporationLabel/* corporationLabels.detail */.n.detail))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormComment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* FormInput */.y, {
                id: "detail",
                type: "text",
                register: register('detail', {
                  required: {
                    value: true,
                    message: '入力してください。'
                  }
                }),
                as: "textarea",
                placeholder: "\u304A\u554F\u5408\u305B\u5185\u5BB9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
                errorMessage: errors.detail,
                defaultValue: form.detail
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "\u203B\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306E\u3054\u63D0\u6848\u306E\u5834\u5408\u306F\u3001\u4EE5\u4E0B\u306E\u3092\u3054\u8A18\u5165\u304F\u3060\u3055\u3044"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "\u3054\u63D0\u6848\u306E\u6982\u8981"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "\u3054\u63D0\u6848\u306E\u8A73\u7D30"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "\u3054\u63D0\u6848\u306E\u671F\u5F85\u52B9\u679C"
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormBottom, {
            children: ["\u3054\u8A18\u5165\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u500B\u4EBA\u60C5\u5831\u306F\u304A\u554F\u5408\u305B\u5BFE\u5FDC\u306E\u305F\u3081\u306B\u3054\u5229\u7528\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u500B\u4EBA\u60C5\u5831\u306E\u53D6\u308A\u6271\u3044\u8A73\u7D30\u306F\u300C", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
              path: "/legal/privacy-policy/",
              text: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
            }), "\u300D\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton, {
            btnStyle: "outline",
            type: "submit",
            children: "\u78BA\u8A8D\u3059\u308B"
          })
        })]
      })]
    })]
  });
};

CorporationPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Inquiry',
    subTitle: 'お問い合わせ'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'お問い合わせ',
    path: '/contact/'
  }, {
    name: '法人',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var CorporationMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__CorporationMain",
  componentId: "sc-8rr9m4-0"
})(["width:1040px;padding-bottom:130px;margin:69px auto 0;@media screen and (max-width:1047px){width:100%;margin:40px auto 0;padding:0 20px 70px;}"]);
var Note = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__Note",
  componentId: "sc-8rr9m4-1"
})(["text-align:left;font-size:16px;line-height:30px;letter-spacing:0.32px;font-weight:400;ol{padding-left:25px;list-style-type:disc;}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"]);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "Corporation__Form",
  componentId: "sc-8rr9m4-2"
})([""]);
var FormMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormMain",
  componentId: "sc-8rr9m4-3"
})(["display:grid;grid-template-columns:240px 1fr;gap:40px 30px;@media screen and (max-width:1047px){grid-template-columns:1fr;gap:16px 0;}"]);
var FormBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormBackground",
  componentId: "sc-8rr9m4-4"
})(["background-color:", ";padding:86px 74px 99px;@media screen and (max-width:1047px){padding:27px 20px 40px;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FormLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormLabelWrapper",
  componentId: "sc-8rr9m4-5"
})(["padding-top:14px;"]);
var FormInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormInner",
  componentId: "sc-8rr9m4-6"
})(["display:flex;align-items:center;column-gap:43px;@media screen and (max-width:1047px){flex-direction:column;align-items:flex-start;row-gap:14px;}"]);
var FormGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormGroup",
  componentId: "sc-8rr9m4-7"
})(["display:flex;align-items:center;column-gap:26px;width:50%;div{flex:1;}@media screen and (max-width:1047px){width:100%;}"]);
var FormComment = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__FormComment",
  componentId: "sc-8rr9m4-8"
})(["display:flex;flex-direction:column;font-size:12px;line-height:26px;color:", ";ol{padding-left:25px;list-style-type:decimal;}"], theme/* theme.colors.grey */.r.colors.grey);
var FormBottom = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Corporation__FormBottom",
  componentId: "sc-8rr9m4-9"
})(["line-height:26px;letter-spacing:0.32px;margin-top:74px;font-weight:400;@media screen and (max-width:1047px){margin-top:36px;font-size:15px;line-height:25px;letter-spacing:0.3px;}"]);
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Corporation__ButtonWrapper",
  componentId: "sc-8rr9m4-10"
})(["display:flex;justify-content:center;margin-top:107px;@media screen and (max-width:1047px){margin-top:54px;}"]);
var SubmitButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "Corporation__SubmitButton",
  componentId: "sc-8rr9m4-11"
})(["width:198px;font-weight:400;border-width:1px;@media screen and (max-width:1047px){font-size:18px;}"]);
;// CONCATENATED MODULE: ./src/pages/contact/corporation/index.tsx


/***/ }),

/***/ 41149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/corporation",
      function () {
        return __webpack_require__(85979);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,825,5548,9774,2888,179], function() { return __webpack_exec__(41149); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);